import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "salesman-small__salesman"
}
const _hoisted_2 = { class: "salesman-small__salesman__image" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "salesman-small__salesman__info" }
const _hoisted_5 = { class: "salesman-small__salesman__header" }
const _hoisted_6 = { class: "salesman-small__salesman__title" }
const _hoisted_7 = { class: "salesman-small__salesman__phone-number" }
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "salesman-small__salesman__buttons" }
const _hoisted_10 = ["href"]
const _hoisted_11 = ["href"]
const _hoisted_12 = ["href"]
const _hoisted_13 = ["href"]

import { PropType } from "vue";
import { ISalesman } from "@/models/ISalesman";
import TressSiteSeparator from "@/components/TressSiteSeparator.vue";
import dictionary from "@/i18n/dictionary.json";


export default /*#__PURE__*/_defineComponent({
  __name: 'TressSalesmanInfo',
  props: {
  salesman: {
    type: Object as PropType<ISalesman>,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_icon_mail = _resolveComponent("icon-mail")!
  const _component_icon_linked_in = _resolveComponent("icon-linked-in")!
  const _component_icon_user = _resolveComponent("icon-user")!

  return (__props.salesman && __props.salesman.fullName)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("img", {
            src: __props.salesman.image1Url
          }, null, 8, _hoisted_3)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(__props.salesman.fullName), 1),
          _createElementVNode("p", _hoisted_6, _toDisplayString(__props.salesman.title), 1),
          _createElementVNode("p", _hoisted_7, [
            _createTextVNode(_toDisplayString(_ctx.$t(_unref(dictionary).common.tel)) + ": ", 1),
            _createElementVNode("a", {
              class: "salesman-small__salesman__phone-number__number",
              href: `tel:${__props.salesman.phoneNumber}`
            }, _toDisplayString(__props.salesman.phoneNumber), 9, _hoisted_8)
          ]),
          _createElementVNode("div", _hoisted_9, [
            (__props.salesman.email)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  class: "salesman-small__salesman__button",
                  href: `mailto:${__props.salesman.email}`
                }, [
                  _createVNode(_component_icon_mail)
                ], 8, _hoisted_10))
              : _createCommentVNode("", true),
            (__props.salesman.linkedInUrl)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  class: "salesman-small__salesman__button",
                  href: __props.salesman.linkedInUrl
                }, [
                  _createVNode(_component_icon_linked_in)
                ], 8, _hoisted_11))
              : _createCommentVNode("", true),
            _createVNode(TressSiteSeparator, null, {
              green: _withCtx(() => [
                (__props.salesman.linkToPageOnGreen)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      class: "salesman-small__salesman__button",
                      href: __props.salesman.linkToPageOnGreen.url
                    }, [
                      _createVNode(_component_icon_user)
                    ], 8, _hoisted_12))
                  : _createCommentVNode("", true)
              ]),
              blue: _withCtx(() => [
                (__props.salesman.linkToPageOnBlue)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      class: "salesman-small__salesman__button",
                      href: __props.salesman.linkToPageOnBlue.url
                    }, [
                      _createVNode(_component_icon_user)
                    ], 8, _hoisted_13))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})